<template>
  <section class="center-card cluster-card">
    <div class="card-title">模糊聚类算法链路</div>
    <div class="chain-lines">
     <img src="@/assets/img/lianlu.png" alt="">
    </div>
    <div class="visual-layer">
      <div class="radar">
        <span v-for="item in 5" :key="item"></span>
        <b></b>
      </div>
      <div class="dot-map">
        <i v-for="dot in dots" :key="dot.id" :style="dot.style"></i>
      </div>
    </div>
  </section>
</template>

<script setup>
const lines = [
  "数据采集 → 降噪修复 → 隶属度计算 → 模糊聚类 → 状态输出",
  "数据采集 → 降噪修复 → 隶属度计算 → 模糊聚类 → 状态输出",
];

const dots = Array.from({ length: 86 }, (_, index) => {
  const col = index % 13;
  const row = Math.floor(index / 13);
  const edge = Math.abs(col - 6) + Math.abs(row - 3);
  const visible = edge < 8 && !(col < 2 && row > 4) && !(col > 10 && row < 1);
  return {
    id: index,
    style: {
      left: `${12 + col * 6.5}%`,
      top: `${14 + row * 10.5}%`,
      opacity: visible ? 0.45 + ((index % 5) * 0.12) : 0.08,
      transform: `scale(${visible ? 0.72 + ((index % 4) * 0.18) : 0.42})`,
    },
  };
});
</script>

<style lang="less" scoped>
@import "./centerPanelShared.less";

.cluster-card {
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
}

.chain-lines {
  position: relative;
  margin-top: 34px;
  display: grid;
  gap: 42px;
  img{
    width: 100%;
    height: 100%;
  }
}

.chain-lines::before {
  content: "";
  position: absolute;
  left: 72px;
  right: 72px;
  top: 50%;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(83, 255, 240, 0.58), transparent);
}

.chain-row {
  position: relative;
  padding: 14px 20px;
  color: #ffffff;
  font-size: 28px;
  font-weight: bold;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
  background: linear-gradient(90deg, rgba(12, 112, 103, 0.74), rgba(35, 190, 174, 0.78), rgba(12, 112, 103, 0.74));
  box-shadow: inset 0 0 18px rgba(84, 255, 240, 0.18), 0 0 12px rgba(52, 237, 223, 0.12);
  margin: 30px 0;
}


.visual-layer {
  position: relative;
  min-height: 318px;
  margin-top: 42px;
}

.radar {
  position: absolute;
  left: 34px;
  bottom: 8px;
  width: 296px;
  height: 296px;
  border-radius: 50%;
  background:
    radial-gradient(circle, rgba(57, 255, 238, 0.5) 0 5px, rgba(57, 255, 238, 0.18) 6px 19px, transparent 20px),
    repeating-radial-gradient(circle, rgba(77, 255, 240, 0.28) 0 1px, transparent 1px 23px);
}

.radar span {
  position: absolute;
  inset: 50%;
  width: 96px;
  height: 1px;
  background: linear-gradient(90deg, rgba(61, 255, 238, 0.75), transparent);
  transform-origin: 0 0;
}

.radar span:nth-child(1) { transform: rotate(0deg); }
.radar span:nth-child(2) { transform: rotate(72deg); }
.radar span:nth-child(3) { transform: rotate(144deg); }
.radar span:nth-child(4) { transform: rotate(216deg); }
.radar span:nth-child(5) { transform: rotate(288deg); }

.radar b {
  position: absolute;
  inset: 28px;
  border: 1px solid rgba(57, 255, 238, 0.36);
  border-radius: 50%;
  box-shadow: inset 0 0 24px rgba(57, 255, 238, 0.13), 0 0 18px rgba(57, 255, 238, 0.18);
}

.dot-map {
  position: absolute;
  right: 20px;
  bottom: 6px;
  width: 490px;
  height: 300px;
}

.dot-map i {
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #60fff2;
  box-shadow: 0 0 9px rgba(96, 255, 242, 0.65);
}
</style>
